<template>
  <table class="table table-hover">
    <tr>
      <template v-for="(header, index) in headers">
        <th v-if="header.show_in_tabel == true" :key="index">
          {{ header.name }}
        </th>
      </template>
    </tr>
    <template v-if="value.length > 0">
      <tr v-for="item in value" :key="item.id">
        <template v-for="(header, index) in headers">
          <td
            v-if="header.type != 'setting' && header.show_in_tabel == true"
            :key="index + 20"
          >
            <span
              v-if="header.type == 'boolean'"
              class="badge"
              :class="{
                'badge-success': item[header.key] == 1,
                'badge-warning': item[header.key] == 0
              }"
            >
              {{ item[header.key] == 1 ? "فعال" : "غیرفعال" }}
            </span>
            <img
              v-if="header.type == 'image'"
              class="image_in_table"
              :src="item[header.key]"
            />
            <span v-if="header.type == 'string'">{{ item[header.key] }}</span>
            <span class="longText" v-if="header.type == 'description'">{{
              item[header.key].length > 31
                ? item[header.key].slice(0, 31) + "..."
                : item[header.key]
            }}</span>
            <span v-if="header.type == 'select'">
              {{ getValue(header.selectIN, item[header.key]) }}
            </span>
            <span v-if="header.type == 'pageLink'">
              {{`pages/${item.id}/`}}
            </span>
          </td>
          <td v-if="header.type == 'setting'" :key="index + 20">
            <b-button
              class="tableButtons"
              v-if="header.edit == true"
              variant="primary"
              @click="showEditModal(item)"
              >ویرایش</b-button
            >
            <b-button
              class="tableButtons"
              v-if="header.delete == true"
              variant="danger"
              @click="deleteItem(item.id)"
              >حذف</b-button
            >
          </td>
        </template>
      </tr>
    </template>
  </table>
</template>
<script>
import { BButton } from "bootstrap-vue";
export default {
  components: {
    BButton
  },
  props: {
    settings: Object,
    headers: Array,
    value: Array
  },
  methods: {
    getValue(selectedIn, value) {
      console.log(selectedIn);
      console.log(value);
      console.log(this.settings[selectedIn]);
      let result = this.settings[selectedIn].filter((item) => {
        if (item.id == value) {
          return item;
        }
      });
      console.log(result);
      if (result.length == 0) return "";
      return result[0].name != undefined ? result[0].name : result[0].label;
    },
    showEditModal(item) {
      this.$emit("showEditModal", item);
    },
    deleteItem(id) {
      this.$emit("deleteItem", id);
    }
  }
};
</script>
<style scoped>
.tableButtons {
  margin-right: 10px;
}
</style>
